import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { externalLinks } from '../data/mock';
import { Calendar, Phone } from 'lucide-react';

const MobileStickyBar = () => {
  const { t } = useLanguage();

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-black border-t border-white/20">
      <div className="grid grid-cols-2">
        <a
          href={externalLinks.naverStore}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 py-4 bg-[#00FFD1] text-black font-semibold text-base"
        >
          <Calendar size={20} />
          {t('reserve')}
        </a>
        <a
          href={externalLinks.phone}
          className="flex items-center justify-center gap-2 py-4 bg-white text-black font-semibold text-base"
        >
          <Phone size={20} />
          {t('call')}
        </a>
      </div>
    </div>
  );
};

export default MobileStickyBar;
